import axios from "axios";
import config from "./config";

const v1 = axios.create(config);

v1.interceptors.request.use(
  function (config) {
    return {
      ...config,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default v1;
